import { render, staticRenderFns } from "./homeMemory.vue?vue&type=template&id=64cdd99d&scoped=true"
import script from "./homeMemory.vue?vue&type=script&lang=js"
export * from "./homeMemory.vue?vue&type=script&lang=js"
import style0 from "./homeMemory.vue?vue&type=style&index=0&id=64cdd99d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cdd99d",
  null
  
)

export default component.exports